let hasRunForThreeGlobal = false;
let hasRunForFourGlobal = false;
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      fetch('/cart.json')
        .then(response => response.json())
        .then(cartData => {
          const inputElement = this.querySelector('form').querySelector('[name=id]').getAttribute('value');
          var variantIdToCheck = Number(inputElement);
          var matchingItems = cartData.items.filter(item => item.variant_id === variantIdToCheck);
          var totalQuantity = matchingItems.reduce((total, item) => total + item.quantity, 0);

          if (document.querySelector('quantity-message')) {
            setTimeout(() => {
              let confettiShooterCount = document.querySelector('quantity-message')?.querySelector('noscript').getAttribute('data-cart-count');   
              if (confettiShooterCount == 2 && hasRunForThreeGlobal == false) {
               hasRunForThreeGlobal = true;
                window.confettiShooter(); }
              // } else if (confettiShooterCount == 4 && hasRunForFourGlobal == false) {
              //   hasRunForFourGlobal = true;
              //   window.confettiShooter();
              // }
            }, 2000);
          }
     

          if (totalQuantity < 4) {
            if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
    
            this.handleErrorMessage();
    
            this.submitButton.setAttribute('aria-disabled', true);
    
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
    
            const formData = new FormData(this.form);
            if (this.cart) {
              formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
              formData.append("quantity", document.querySelector("product-info quantity-input input")?.value);
            }
            config.body = formData;
    
            fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  this.handleErrorMessage(response.description);
    
                  const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute('aria-disabled', true);
                  this.submitButton.querySelector('span').classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                  this.error = true;
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }
    
                var event = new CustomEvent('product:added', {
                  detail: response
                });
                document.dispatchEvent(event);
    
                if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form'
                });
                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener('modalClosed', () => {
                    setTimeout(() => {
                      this.cart.renderContents(response)
                    });
                  }, {
                    once: true
                  });
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                  this.cart.addFreebie();      
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              });
          } else {
            alert(`You can order only 4 items per SKU from our store, kindly call our Customer Connect (+91) 9357 933 933 for bulk buying. Thank You!`);
          }
        })
        .catch(error => {
          console.error('Error fetching cart data:', error);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

